/**
 * A composable function that provides a utility for fixing the height within a specified range.
 */
export function useFixHeight() {
    /**
     * The minimum height allowed (200).
     */
    const MIN_HEIGHT = 200;
    /**
     * The maximum height allowed (480).
     */
    const MAX_HEIGHT = 480;

    /**
     * Gets the fixed height within the specified range.
     * @param height - The height to be fixed.
     * @returns The fixed height within the range of MIN_HEIGHT and MAX_HEIGHT.
     */
    function fixHeight (height: number) {
        if (height <= MIN_HEIGHT) {
            return MIN_HEIGHT;
        } else if (height >= MAX_HEIGHT) {
            return MAX_HEIGHT;
        }
        return height;
    }

    return {
        /**
         * Gets the fixed height within the specified range.
         * @param height - The height to be fixed.
         * @returns The fixed height within the range of MIN_HEIGHT and MAX_HEIGHT.
         */
        fixHeight,
    };
}
